import { createInstance } from "i18next";

import { sharedUS } from "@shared/locales";
import { baseI18nConfig } from "@shared/locales/baseI18nConfig";

const experimentTesterI18n = createInstance();
experimentTesterI18n.init({
  ...baseI18nConfig,
  ns: Object.keys(sharedUS),
  resources: {
    en: { ...sharedUS },
  },
});

export { experimentTesterI18n };
